/* eslint-disable @typescript-eslint/no-explicit-any */
// TODO: This file was automatically migrated to TypeScript by `dev typescript migrate`.
//  The eslint disable comment above should be removed and the resulting errors fixed.
/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS104: Avoid inline assignments
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */

import $ from 'jquery';
import React from 'react';
import _ from 'underscore';

import {ValueLink} from 'constants/CRISPRConstants';
import * as FolderConstants from 'constants/FolderConstants';
import {SequenceSummary} from 'constants/SequenceConstants';
import FolderDAO from 'file-browser/FolderDAO';
import notifications from 'notifications';
import ProgressBar from 'ui-library/bs/ProgressBar';
import FileChooser from 'ui-library/FileChooser';
import * as ImportUtil from 'util/ImportUtil';
import {SequenceImportResponse, SuccessResult} from 'util/ImportUtil';

export function isValidFolderType(folderType: FolderConstants.FolderType): boolean {
  const validFolderTypes = [
    FolderConstants.Type.ALL,
    FolderConstants.Type.INVENTORY,
    FolderConstants.Type.NOTEBOOK,
  ];
  return validFolderTypes.includes(folderType);
}

interface Props {
  folderId?: string;
  importErrorLink: ValueLink<string | null>;
  multi: boolean;
  updateSequences: (sequences: Array<SequenceSummary>) => void;
}

interface State {
  importProgress: null | number;
}

class SequenceImportInput extends React.Component<Props, State> {
  static defaultProps = {
    multi: true,
  };

  _isMounted!: boolean;

  state: State = {
    importProgress: null,
  };

  componentDidMount(): void {
    this._isMounted = true;
  }

  componentWillUnmount(): void {
    this._isMounted = false;
  }

  updateImportProgress = (importProgress: number | null): void => {
    if (!this._isMounted) {
      return;
    }
    this.setState({importProgress});
  };

  _selectFolderForUpload = (): JQueryDeferred<string> => {
    const folderDeferred = $.Deferred<string>();
    FolderDAO.fetchAll({level: 'append'})
      .done((folders: Array<FolderConstants.MinimalFolder>) => {
        if (!folders.length) {
          notifications.error('No projects found. Create one to continue.');
          this.setState({importProgress: null});
          folderDeferred.reject();
        } else {
          const validFolders = folders.filter((folder: FolderConstants.MinimalFolder) =>
            isValidFolderType(folder.type)
          );
          const folder = _.findWhere(folders, {api_identifier: this.props.folderId}) || validFolders[0];
          folderDeferred.resolve(folder.api_identifier);
        }
      })
      .fail((res: any) => {
        notifications.notifyError(res);
        folderDeferred.reject();
      });
    return folderDeferred;
  };

  handleFileSelected = (file: File): void => {
    this.setState({importProgress: 0});
    this._selectFolderForUpload().done((folderId: string) => {
      this.props.importErrorLink.requestChange(null);
      ImportUtil.uploadSequence(file, folderId, this.props.multi)
        .progress(this.updateImportProgress)
        .always(() => {
          if (this._isMounted) {
            this.setState({importProgress: null});
          }
        })
        .done(({results}: SequenceImportResponse) => {
          if (!this._isMounted) {
            return;
          }
          for (const sequence of Array.from(results)) {
            if (sequence.status === 'error') {
              this.props.importErrorLink.requestChange(sequence.message);
              return;
            }
          }
          this.props.updateSequences(results as Array<SuccessResult>);
        })
        .fail(({message}: any) => {
          if (this._isMounted) {
            // eslint-disable-next-line @typescript-eslint/no-confusing-void-expression
            return this.props.importErrorLink.requestChange(message);
          }
        });
    });
  };

  render(): JSX.Element {
    return (
      <div>
        {this.state.importProgress == null ? (
          <FileChooser onSelectFiles={this.handleFileSelected} />
        ) : (
          <ProgressBar active={true} striped={true} value={this.state.importProgress} />
        )}
        {this.props.importErrorLink.value ? (
          <div className="alert alert-danger">{this.props.importErrorLink.value}</div>
        ) : undefined}
      </div>
    );
  }
}

export default SequenceImportInput;
